import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import {
	downloadPatientsListCsv,
	type PatientFilters,
} from '@/api/adapters/patients';
import { toast } from '@/app/store/toast.store';

export interface ExportPatientsCsvVariables {
	filters: PatientFilters;
	total: number;
}

/**
 * Mutation hook for the patient-list CSV export (FEATURE_013).
 *
 * Handles toast notifications internally — the caller only calls
 * `mutate({ filters, total })`. The button should bind `isPending`
 * for its disabled/loading state.
 */
export function useExportPatientsCsv() {
	const { t } = useTranslation('medical');

	return useMutation<void, Error, ExportPatientsCsvVariables>({
		mutationFn: ({ filters }) => downloadPatientsListCsv(filters),
		onSuccess: (_data, { total }) => {
			toast.success(t('home.patientList.csvExportSuccess', { count: total }));
		},
		onError: () => {
			toast.error(t('home.patientList.csvExportError'));
		},
	});
}
